/* eslint-disable no-undef */
import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children?: ReactNode;
}

const Page: React.FC<PageProps> = (props) => {
  const { title, children, ...rest } = props;

  return (
    <div {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
};

export default Page;
